import React, { useCallback, useState, useReducer, useEffect, useMemo } from 'react';
import { captureException } from '@sentry/browser';
import { track } from '@zillow/universal-analytics';
import styled, { css } from 'styled-components';
import { AdornedInput, token, spaceMixin, Flex, mediaMixin, Spacer, Label, Paragraph, Input, Adornment, FormHelp, ModalDialog, Heading, Form, IconUser, IconPhone, IconMail, FormActions, Button, Anchor, Alert, Text, IconCheckmarkCircle } from '@zillow/constellation';
import queryString$1 from 'query-string';
import mailcheck from 'mailcheck';
import trim from 'lodash/trim';
import get from 'lodash/get';
import isNaN from 'lodash/isNaN';
import keys from 'lodash/keys';
import Ajv from 'ajv';
import OtherWaysToSell from '@zillow/zo-other-ways-to-sell';
import AbadEcClient from '@zillow/abad-ec-sdk';
import parse from 'html-react-parser';
import axios from 'axios';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

// https://gist.github.com/paulirish/5558557#stronger-full-capability-test-for-localstorage-with-ios-private-browsing-protection

// UPDATED: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return false;
    }
}
function isLocalStorageSupported() {
    return storageAvailable('localStorage');
}

function isSessionStorageSupported() {
    return storageAvailable('sessionStorage');
}

var isLocalStorageSupported_1 = {
    isLocalStorageSupported: isLocalStorageSupported,
    isSessionStorageSupported: isSessionStorageSupported
};
var isLocalStorageSupported_2 = isLocalStorageSupported_1.isLocalStorageSupported;
var isLocalStorageSupported_3 = isLocalStorageSupported_1.isSessionStorageSupported;

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["dedup"];
/**
 * Parse url search string into an object.
 * Object property keys are the parameter names, and corresponding property values are the parameter values.
 * By default, if there are multiple parameters with the same name pick the last one.
 */

function enhancedParse(search) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var {
    dedup = true
  } = _ref,
      restOptions = _objectWithoutProperties$1(_ref, _excluded);

  try {
    var result = queryString$1.parse(search, restOptions);
    Object.keys(result).forEach(key => {
      var resultValue = result[key];

      if (dedup && resultValue instanceof Array) {
        // Only take the last value
        result[key] = resultValue[resultValue.length - 1];
      } // 'novalue&' will be parsed as { novalue: null }
      // we want to clean up all keys with null values
      // so that later they will not be included for stringify


      if (result[key] === null || result[key] === undefined) {
        // eslint-disable-next-line zillow/@typescript-eslint/no-dynamic-delete
        delete result[key];
      }
    }); // the object returned from queryString.parse has null prototype (Object.getPrototypeOf)
    // convert it to an object literal
    // so it can be compared with other object literal using strict equality

    return _objectSpread2$1({}, result);
  } catch (err) {
    console.warn(err);
    return {};
  }
}
/**
 * Merge multiple query strings into one, if there are multiple parameters with the same name, pick the last one.
 * E.g. merge('a=a&b=b', 'c=c', 'c=c2&d=d') => 'a=a&b=b&c=c2&d=d'
 */


function merge() {
  for (var _len = arguments.length, searches = new Array(_len), _key = 0; _key < _len; _key++) {
    searches[_key] = arguments[_key];
  }

  var search = searches.filter(s => !!s).join('&');
  var queryParams = enhancedParse(search);
  return queryString$1.stringify(queryParams);
}

var queryString = _objectSpread2$1(_objectSpread2$1({}, queryString$1), {}, {
  merge,
  parse: enhancedParse
});

var createInternalStorage = () => {
  var mapInstance = new Map();
  return {
    getItem: key => mapInstance.get(key),
    removeItem: key => {
      mapInstance.delete(key);
    },
    setItem: (key, value) => mapInstance.set(key, value !== null && value !== void 0 ? value : null)
  };
};
/**
 * Detect whether current javascript runtime is a browser-like environment
 * (including mobile browser and RE app webview).
 */


function isBrowser() {
  return typeof window === 'object';
}

var getLocalStorageAPI = () => {
  var KEY_PREFIX = 'static-zo-growth-';
  var localStorage;

  if (isLocalStorageSupported_2()) {
    ({
      localStorage
    } = window);
  } else {
    localStorage = createInternalStorage();
  }

  return {
    getItem: key => {
      try {
        return localStorage.getItem("".concat(KEY_PREFIX).concat(key));
      } catch (_unused) {
        return null;
      }
    },
    removeItem: key => {
      try {
        localStorage.removeItem("".concat(KEY_PREFIX).concat(key));
        return undefined;
      } catch (_unused2) {
        return undefined;
      }
    },
    setItem: (key, value) => {
      try {
        localStorage.setItem("".concat(KEY_PREFIX).concat(key), value);
        return undefined;
      } catch (_unused3) {
        return undefined;
      }
    }
  };
};

var localStorageAPI = getLocalStorageAPI();

function getFromLocalStorage(key) {
  return localStorageAPI.getItem(key);
}

var fallbackWindow = {
  location: {
    search: ''
  },
  navigator: {
    userAgent: ''
  }
};
/**
 * Returns global window object if it is available.
 * Otherwise, return a fallback window object.
 */

var getGlobalWindow = () => {
  if (!isBrowser()) {
    return fallbackWindow;
  }

  return window;
};

class SimpleBus {
  constructor() {
    var _this = this;

    _defineProperty$1(this, "listenerList", void 0);

    _defineProperty$1(this, "callListeners", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this.listenerList.forEach(subFunc => {
        subFunc(...args);
      });
    });

    _defineProperty$1(this, "addListener", func => {
      this.listenerList.push(func);
      var wrapper = {
        cancel: () => {
          this._removeListener(func);
        },
        func
      };
      return wrapper;
    });

    _defineProperty$1(this, "_removeListener", func => {
      var index = this.listenerList.indexOf(func);
      this.listenerList = [...this.listenerList.slice(0, index), ...this.listenerList.slice(index + 1)];
    });

    this.listenerList = [];
  }

}

var getSessionStorageAPI = () => {
  var KEY_PREFIX = 'static-zo-growth-';
  var globalWindow = getGlobalWindow();
  var sessionStorage; // in strict mode, error will be thrown if window is never defined and is used directly in boolean expression

  if (isLocalStorageSupported_3() && globalWindow) {
    ({
      sessionStorage
    } = globalWindow);
  } else {
    sessionStorage = createInternalStorage();
  }

  return {
    getItem: key => sessionStorage.getItem("".concat(KEY_PREFIX).concat(key)),
    removeItem: key => sessionStorage.removeItem("".concat(KEY_PREFIX).concat(key)),
    setItem: (key, value) => sessionStorage.setItem("".concat(KEY_PREFIX).concat(key), value)
  };
};

var SessionStorageAPI = getSessionStorageAPI();
var simpleFunctionBus = new SimpleBus();

function getIsMobileWeb() {
  var _getGlobalWindow2;

  return Boolean((_getGlobalWindow2 = getGlobalWindow()) === null || _getGlobalWindow2 === void 0 ? void 0 : _getGlobalWindow2.navigator.userAgent.includes('Mobi'));
}
/**
 * isAppWebView
 */


var IS_APP_WEB_VIEW_KEY = 'isMobileAppWebView';

function getIsAppWebView() {
  var globalWindow = getGlobalWindow();
  var {
    fromapp,
    fromApp
  } = queryString.parse(globalWindow === null || globalWindow === void 0 ? void 0 : globalWindow.location.search); // handy override for debugging purpose

  if (fromapp === 'false' || fromApp === 'false') {
    return false;
  }

  var isMobileAppWebViewLocalStorage = Boolean(getFromLocalStorage(IS_APP_WEB_VIEW_KEY));
  var isIOS = Boolean(fromapp) || Boolean(fromApp) || isMobileAppWebViewLocalStorage;
  var isAndroid = Boolean(globalWindow === null || globalWindow === void 0 ? void 0 : globalWindow.navigator.userAgent.includes('ZillowApp'));
  return isIOS || isAndroid;
}

function getIsMobile() {
  return getIsAppWebView() || getIsMobileWeb();
}

var JMP_BASE = '/jmp';
var Urls = {
  CHESS_AUTOCOMPLETE_URL: 'https://www.zillowstatic.com/autocomplete/v3/suggestions',
  CHESS_AUTOCOMPLETE_URL_QA: 'https://static.qa.zillow.net/autocomplete/v3/suggestions',
  LEAD_ELIGIBILITY_CHECK: "".concat(JMP_BASE, "/lead-eligibility"),
  LEADS_NURTURE: "".concat(JMP_BASE, "/leads/nurture"),
  LEADS_PARTNER_LEADS_ELIGIBILITY_LIST: "".concat(JMP_BASE, "/leads/partner-leads-interest-list"),
  TERMS_OF_SERVICE_PATH: '/corp/Terms.htm',
  ZILLOW_OFFERS_ADDRESS_SEARCH: "".concat(JMP_BASE, "/address-search"),
  ZILLOW_OFFERS_DETAILED_ADDRESS_SEARCH: "".concat(JMP_BASE, "/detailed-address-search"),
  ZILLOW_OFFERS_SELLER_QUESTIONNAIRE_ELIGIBILITY_CHECK: "".concat(JMP_BASE, "/questionnaire-eligibility-check")
};

var checkEmail = email => mailcheck.run({
  email,
  secondLevelDomains: mailcheck.defaultSecondLevelDomains.filter(e => e !== 'gmx')
});

var _excluded$1 = ["id", "isOptional", "isRequired", "errorMessage", "isFollowUp", "onBlur", "onChange", "overlay", "title", "className", "subtitle"];

var _templateObject, _templateObject2;
// ignore prettier, since it tries to remove the parenthesis, which cause this eslint rule to fail
// https://eslint.org/docs/rules/no-confusing-arrow
// prettier-ignore

var StyledAdornedInput = styled(AdornedInput)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    input,\n    label {\n        background-color: ", ";\n        border-color: ", ";\n        caret-color: currentcolor;\n        padding: ", " !important;\n        margin: 0;\n    }\n\n    label {\n        padding-right: 0 !important;\n    }\n"])), props => props.error ? token('colors.red100') : undefined, props => props.error ? token('colors.red400') : undefined, spaceMixin('xs'));
var StyleWrapper = styled(Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    /* Remove margin from last child to avoid margin-collapse which mess up followup animation */\n    &.is-followup:last-child {\n        margin-bottom: 0;\n    }\n\n    .input-field-sub-title {\n        display: block;\n        color: ", ";\n        font-size: 15px;\n        margin-bottom: 10px;\n    }\n\n    ", "\n"])), token('colors.textMedium'), mediaMixin('md', css(["&.is-followup{width:400px;}"])));

var InputField = _ref => {
  var {
    id,
    isOptional = false,
    isRequired = false,
    errorMessage,
    isFollowUp,
    onBlur,
    onChange = () => {},
    overlay,
    title,
    className = '',
    subtitle
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1);

  // The idea was that we want to know whether user has interacted with the
  // form field or not to prefill with constant value in questionnaire. This includes:
  // - Typing value
  // - Tab/focus out.
  // This idea was due to the requirement of Contact Info page
  // where we only prefill Contact info if user has not interacted with the field.
  var onBlurCallback = useCallback(event => {
    if (onBlur) {
      onBlur(id, event.target.value);
    } else {
      onChange(id, event.target.value);
    }
  }, [id, onChange, onBlur]);
  var onChangeCallback = useCallback(e => {
    onChange(id, e.target.value);
  }, [onChange, id]);
  return /*#__PURE__*/React.createElement(StyleWrapper, {
    marginBottom: "sm",
    className: "".concat(className, " ").concat(isFollowUp ? 'is-followup' : '')
  }, title && /*#__PURE__*/React.createElement(Spacer, {
    marginBottom: "xs"
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    size: "lg",
    required: isRequired,
    optional: isOptional
  }, title)), subtitle && /*#__PURE__*/React.createElement(Paragraph, {
    className: "input-field-sub-title"
  }, subtitle), /*#__PURE__*/React.createElement(StyledAdornedInput, {
    error: Boolean(errorMessage),
    input: /*#__PURE__*/React.createElement(Input, _extends({
      id: id,
      maxLength: 500,
      onChange: onChangeCallback,
      onBlur: onBlurCallback
    }, otherProps)),
    leftAdornment: overlay ? /*#__PURE__*/React.createElement(Adornment, null, overlay) : undefined
  }), /*#__PURE__*/React.createElement(Spacer, {
    marginTop: "xs"
  }, /*#__PURE__*/React.createElement(FormHelp, {
    error: true
  }, errorMessage)));
};

/* global document */

/**
 * Return this phone number with separation characters:
 *
 * @example
 * 123 => (123)
 * (123) 456 => (123) 456-
 * (123) 456-78901 => (123) 456-7890 x1
 * 1234567890 => (123) 456-7890
 * 12345678901234 => (123) 456-7890 x1234
 *
 * @param {Number|String} n
 * @return {String}
 */
function phoneNumber(num) {
    var areaCodeRegex = /^(\d{3})$/;
    var firstThreeDigitsRegex = /^(\(\d{3}\) \d{3})(-*)$/;
    var extensionRegex = /^(\(\d{3}\) \d{3}-\d{4})(\d+)$/;
    var extensionWithSpaceRegex = /^(\(\d{3}\) \d{3}-\d{4})(\s+)$/;
    var fullNumberRegex = /^(\d{3})(\d{3})(\d{4})$/;
    var fullNumberWithExtensionRegex = /^(\d{3})(\d{3})(\d{4})(\d+)$/;

    var n = '' + num;

    if (areaCodeRegex.test(n)) {
        n = n.replace(areaCodeRegex, '($1) ');
    } else if (firstThreeDigitsRegex.test(n)) {
        n = n.replace(firstThreeDigitsRegex, '$1-');
    } else if (extensionRegex.test(n)) {
        n = n.replace(extensionRegex, '$1 x$2');
    } else if (extensionWithSpaceRegex.test(n)) {
        n = n.replace(extensionWithSpaceRegex, '$1 x');
    } else if (fullNumberRegex.test(n)) {
        n = n.replace(fullNumberRegex, '($1) $2-$3');
    } else if (fullNumberWithExtensionRegex.test(n)) {
        n = n.replace(fullNumberWithExtensionRegex, '($1) $2-$3 x$4');
    }

    return n;
}

var phoneNumberFormatter = value => {
  if (!value) {
    return '';
  } // Remove all non-digit character, so that the formatter can work correctly


  return phoneNumber(value.replace(/\D/gi, ''));
};

var PhoneNumberField = _ref => {
  var {
    id,
    isOptional,
    name,
    value,
    title = '',
    onChange,
    onBlur: _onBlur = () => {},
    errorMessage,
    isRequired,
    overlay,
    placeholder = '(555) 555-5555'
  } = _ref;
  return /*#__PURE__*/React.createElement(InputField, {
    autoComplete: "tel",
    id: id,
    isOptional: isOptional,
    name: name,
    isRequired: isRequired,
    inputMode: "tel",
    overlay: overlay,
    title: title,
    type: "tel",
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onBlur: (fieldId, newValue) => {
      if (_onBlur) {
        var formattedPhoneNumber = phoneNumberFormatter(trim(newValue));

        _onBlur(fieldId, formattedPhoneNumber);
      }
    },
    errorMessage: errorMessage
  });
};

var ajvJSONValidator = new Ajv({
  allErrors: true
});
var getPropertyValidationErrorMessage = (ajvError, validationSchema) => {
  // Extract property name from data path
  var {
    dataPath,
    message: defaultMessage
  } = ajvError; // Handle several format of dataPath. Eg:
  // ["property"] - Normal property validation
  // .property - "pattern" validation

  var propertyName = trim(dataPath, "[]'.");
  var propertyErrorMessage = get(validationSchema, "properties.".concat(propertyName, ".errorMessage"), defaultMessage);
  return {
    [propertyName]: propertyErrorMessage
  };
};
var getRequiredErrorMessage = (ajvError, validationSchema) => {
  var {
    message: defaultMessage,
    params: {
      missingProperty
    }
  } = ajvError;
  var propertyErrorMessage = get(validationSchema, "properties.".concat(missingProperty, ".errorMessage"), defaultMessage);
  return {
    [missingProperty]: propertyErrorMessage
  };
};
var getJsonValidatorErrorMessages = (ajvErrors, schema) => {
  if (!ajvErrors || !ajvErrors.length) {
    return {};
  }

  return ajvErrors.reduce((prev, error) => {
    var {
      keyword
    } = error;

    if (keyword === 'required') {
      return _objectSpread2(_objectSpread2({}, prev), getRequiredErrorMessage(error, schema));
    }

    return _objectSpread2(_objectSpread2({}, prev), getPropertyValidationErrorMessage(error, schema));
  }, {});
}; // Clean up NaN answers properties to avoid ajv error

var validateRequiredJsonFormat = (answers, schema) => keys(answers).filter(property => !keys(schema.properties).includes(property) || !isNaN(answers[property])).reduce((validateAnswers, property) => {
  var answersValidator = validateAnswers;
  answersValidator[property] = answers[property];
  return answersValidator;
}, {});
var buildValidationResult = (answers, schema) => {
  var validateAnswers = validateRequiredJsonFormat(answers, schema);
  var isValid = ajvJSONValidator.validate(schema, validateAnswers);
  var errorMessages = getJsonValidatorErrorMessages(ajvJSONValidator.errors, schema);
  return {
    errorMessages,
    isValid
  };
};

var ContactInfoFields = {
  EMAIL: 'email',
  NAME: 'name',
  PHONE: 'phone'
};

/* eslint-disable zillow/@typescript-eslint/naming-convention */
var Regex = {
  // a slightly different regex based on RX_EMAIL in @zillow/validation-regexes
  // to support uppercase letter in an email address
  RX_EMAIL: // eslint-disable-next-line max-len
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/i,
  RX_NON_EMPTY_TEXT: /^.*\S.*$/,
  // Valid phone numbers WITHOUT extension, according to the North American Numbering Plan
  // http://blog.stevenlevithan.com/archives/validate-phone-number#r4-2-v-invalid
  // e.g. 1234567890, 123-456-7890, 123.456.7890, 123 456 7890, (123) 456 7890
  RX_PHONE_NO_EXT: /^\(?([2-9][0-8][0-9])\)?[-. ]?([2-9][0-9]{2})[-. ]?([0-9]{4})$/,
  // Same as the above, but allow empty string
  RX_PHONE_NO_EXT_OPTIONAL: /^(\(?([2-9][0-8][0-9])\)?[-. ]?([2-9][0-9]{2})[-. ]?([0-9]{4}))?$/
};

var getValidationSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  properties: {
    [ContactInfoFields.NAME]: {
      errorMessage: 'Please enter a valid name.',
      minLength: 1,
      pattern: Regex.RX_NON_EMPTY_TEXT.source,
      type: 'string'
    },
    [ContactInfoFields.EMAIL]: {
      errorMessage: 'Please enter a valid email address.',
      minLength: 1,
      pattern: Regex.RX_EMAIL.source,
      type: 'string'
    },
    [ContactInfoFields.PHONE]: {
      errorMessage: 'Please enter a valid 10-digit phone number.',
      minLength: 1,
      pattern: Regex.RX_PHONE_NO_EXT.source,
      type: 'string'
    }
  },
  required: [ContactInfoFields.NAME, ContactInfoFields.PHONE, ContactInfoFields.EMAIL],
  type: 'object'
};
var buildContactInfoValidationSchema = fieldNames => {
  var schema = getValidationSchema;

  if (!fieldNames) {
    return schema;
  }

  var filteredFieldNames = fieldNames.filter(name => Object.values(ContactInfoFields).includes(name));

  var newSchema = _objectSpread2(_objectSpread2({}, schema), {}, {
    properties: filteredFieldNames.reduce((hash, fieldName) => _objectSpread2(_objectSpread2({}, hash), {}, {
      [fieldName]: schema.properties[fieldName]
    }), {}),
    required: [...filteredFieldNames]
  });

  return newSchema;
};

var ContactFormActions = {
  INIT: 'INIT',
  SET_EMAIL: 'SET_EMAIL',
  SET_NAME: 'SET_NAME',
  SET_PHONE: 'SET_PHONE'
};

var emptyContactInfo = {
  [ContactInfoFields.EMAIL]: '',
  [ContactInfoFields.NAME]: '',
  [ContactInfoFields.PHONE]: ''
};
var initContactInfo = contactInfo => {
  // initialize full address object with passed-in contactInfo object
  if (contactInfo) {
    return _objectSpread2(_objectSpread2({}, emptyContactInfo), contactInfo);
  }

  return emptyContactInfo;
};
var fullContactInfoReducer = (state, action) => {
  switch (action.type) {
    case ContactFormActions.INIT:
      return initContactInfo(action.payload);

    case ContactFormActions.SET_EMAIL:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        email: action.payload
      });

    case ContactFormActions.SET_NAME:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        name: action.payload
      });

    case ContactFormActions.SET_PHONE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        phone: action.payload
      });

    default:
      throw new Error('Failed to update contact information!');
  }
};

var _templateObject$1, _templateObject2$1, _templateObject3;
var isMobile = getIsMobile();
var {
  EMAIL,
  NAME,
  PHONE
} = ContactInfoFields;
var INITIAL_TOUCH_STATE = {
  [EMAIL]: false,
  [NAME]: false,
  [PHONE]: false
}; // ******** Styles ***************

var StyleWrapper$1 = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    margin: 0 ", ";\n"])), spaceMixin('sm'));
var StyledSubmissionError = styled(Paragraph)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), token('colors.red400'));
var StyledDisclaimer = styled(Paragraph)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 8px;\n    line-height: 12px;\n"]))); // ******** GA Tracking ***************

var trackDisplay = (isEligible, landingPage, contactFormGaActionPrefix) => {
  var actionPrefix = landingPage === '360LandingPage' ? '360' : 'PL';

  if (contactFormGaActionPrefix) {
    actionPrefix = contactFormGaActionPrefix;
  }

  return isEligible ? track({
    action: "".concat(actionPrefix, "LeadFormModal"),
    category: landingPage,
    label: 'LeadForm_Display'
  }) : track({
    action: "".concat(actionPrefix, "InterestListModal"),
    category: landingPage,
    label: 'InterestList_Display'
  });
};

var contactInfoValidationSchema = buildContactInfoValidationSchema(Object.keys(emptyContactInfo));

var ContactFormDialog = _ref => {
  var {
    prefillContactInfo,
    content,
    onClose,
    contactFormGaActionPrefix,
    isEligible,
    isOpen,
    landingPage,
    leadSubmissionError,
    onFieldBlur,
    onLeadSubmit
  } = _ref;
  var [emailSuggestion, setEmailSuggestion] = useState(undefined);
  var [touched, setTouched] = useState(INITIAL_TOUCH_STATE);
  var [fullContactInfo, dispatch] = useReducer(fullContactInfoReducer, prefillContactInfo, initContactInfo);
  var errors = buildValidationResult(fullContactInfo, contactInfoValidationSchema);

  var onBlur = id => {
    setTouched(_objectSpread2(_objectSpread2({}, touched), {}, {
      [id]: true
    }));
    onFieldBlur(id);
  };

  var onSubmit = e => {
    e.preventDefault();
    onLeadSubmit(fullContactInfo);
  };

  var checkEmailSuggestion = email => {
    setEmailSuggestion(checkEmail(email));
  };

  var getInputErrMsg = id => errors.errorMessages[id];

  useEffect(() => {
    if (isOpen) {
      trackDisplay(isEligible, landingPage, contactFormGaActionPrefix);
    }
  }, [isEligible, isOpen, landingPage, contactFormGaActionPrefix]);
  useEffect(() => {
    if (!isOpen) {
      dispatch({
        payload: prefillContactInfo,
        type: ContactFormActions.INIT
      });
      setTouched(INITIAL_TOUCH_STATE);
    }
  }, [prefillContactInfo, isOpen]);
  return /*#__PURE__*/React.createElement(ModalDialog, {
    shouldCloseOnOutsideClick: false,
    shouldCloseOnESCKeyPress: false,
    size: isMobile ? ModalDialog.SIZES.FULL_SCREEN : ModalDialog.SIZES.MD,
    header: /*#__PURE__*/React.createElement(Heading, {
      style: {
        fontSize: '16px'
      },
      paddingX: "md",
      level: "6"
    }, content.header),
    body: /*#__PURE__*/React.createElement(StyleWrapper$1, {
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(Heading, {
      level: "6"
    }, content.bodyHeading), /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "sm"
    }, content.bodySubHeading), /*#__PURE__*/React.createElement(Form, {
      onSubmit: onSubmit
    }, /*#__PURE__*/React.createElement(InputField, {
      overlay: /*#__PURE__*/React.createElement(IconUser, null),
      autoComplete: NAME,
      id: NAME,
      name: NAME,
      value: fullContactInfo[NAME],
      minLength: "1",
      onBlur: onBlur,
      onChange: (id, newVal) => dispatch({
        payload: newVal,
        type: ContactFormActions.SET_NAME
      }),
      placeholder: "Name",
      errorMessage: touched.name && getInputErrMsg(NAME)
    }), /*#__PURE__*/React.createElement(PhoneNumberField, {
      overlay: /*#__PURE__*/React.createElement(IconPhone, null),
      id: PHONE,
      name: PHONE,
      value: fullContactInfo[PHONE],
      minLength: "1",
      onBlur: onBlur,
      onChange: (id, newVal) => dispatch({
        payload: newVal,
        type: ContactFormActions.SET_PHONE
      }),
      placeholder: "Phone",
      errorMessage: touched.phone && getInputErrMsg(PHONE)
    }), /*#__PURE__*/React.createElement(InputField, {
      overlay: /*#__PURE__*/React.createElement(IconMail, null),
      autoComplete: EMAIL,
      id: EMAIL,
      name: EMAIL,
      value: fullContactInfo[EMAIL],
      placeholder: "name@email.com",
      minLength: "1",
      onBlur: onBlur,
      onChange: (id, newVal) => {
        dispatch({
          payload: newVal,
          type: ContactFormActions.SET_EMAIL
        });
        checkEmailSuggestion(newVal);
      },
      errorMessage: touched.email && getInputErrMsg(EMAIL)
    }), !getInputErrMsg('email') && emailSuggestion && /*#__PURE__*/React.createElement(Spacer, {
      marginTop: "sm",
      marginBottom: "sm"
    }, /*#__PURE__*/React.createElement(FormHelp, {
      "data-testid": "email-suggestion"
    }, "Did you mean ", emailSuggestion.address, "@", /*#__PURE__*/React.createElement("strong", null, emailSuggestion.domain), "?")), leadSubmissionError && /*#__PURE__*/React.createElement(StyledSubmissionError, {
      marginTop: "sm",
      fontType: "body"
    }, leadSubmissionError), /*#__PURE__*/React.createElement(FormActions, {
      style: {
        marginTop: '16px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: !errors.isValid,
      fluid: true,
      buttonType: "primary",
      type: "submit",
      "data-testid": "lead-submit-button"
    }, "Submit"))), /*#__PURE__*/React.createElement(StyledDisclaimer, {
      fontType: "legal",
      marginY: "sm",
      "data-testid": "consumer-term-panel",
      style: {
        textAlign: 'left'
      }
    }, "By pressing \u201CSubmit\u201D, you agree that Zillow Group and real estate professionals may call/text you about your inquiry, which may involve use of automated means and prerecorded/artificial voices. You don't need to consent as a condition of buying any property, goods or services. Message/data rates may apply. You also agree to our", ' ', /*#__PURE__*/React.createElement(Anchor, {
      href: Urls.TERMS_OF_SERVICE_PATH
    }, "Terms of Use"), ".")),
    onClose: onClose,
    isOpen: isOpen,
    "data-testid": "lead-contact-form-dialog"
  });
};

ContactFormDialog.defaultProps = {
  contactFormGaActionPrefix: '',
  isOpen: false,
  landingPage: '',
  leadSubmissionError: '',
  onClose: () => {},
  onFieldBlur: () => {},
  prefillContactInfo: {}
};

var _templateObject$2;
var isMobile$1 = getIsMobile();
var ButtonWrapper = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n    width: 100%;\n    ", ";\n"])), mediaMixin('md', css(["max-width:200px;"])));

var ABADisclosureDialog = _ref => {
  var {
    documentContent,
    isOpen,
    onClose
  } = _ref;
  var body = /*#__PURE__*/React.createElement(Flex, {
    margin: "sm"
  }, /*#__PURE__*/React.createElement(Alert, {
    "data-testid": "abad-intro",
    body: /*#__PURE__*/React.createElement(Paragraph, null, "Zillow has affiliated businesses that help make home buying and selling easier. You have not agreed to work with any of these affiliates. This is only meant to inform you in case you want to in the future.")
  }), /*#__PURE__*/React.createElement(Text, {
    fontType: "finePrint"
  }, /*#__PURE__*/React.createElement(Flex, {
    "data-testid": "abad-body",
    marginTop: "md"
  }, documentContent)));
  return /*#__PURE__*/React.createElement(ModalDialog, {
    "data-testid": "abad-panel",
    isOpen: isOpen,
    wide: true,
    onClose: () => {},
    closeButton: null,
    shouldCloseOnOutsideClick: false,
    shouldCloseOnESCKeyPress: false,
    size: isMobile$1 ? ModalDialog.SIZES.FULL_SCREEN : ModalDialog.SIZES.XS,
    header: /*#__PURE__*/React.createElement(Heading, {
      level: 4,
      marginLeft: "lg",
      marginRight: "lg"
    }, "What you need to know about ", /*#__PURE__*/React.createElement("b", null, "Zillow"), " and its affiliated businesses"),
    footer: /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "close-button",
      fluid: true,
      buttonType: "primary",
      onClick: onClose
    }, "Ok, got it!")),
    body: body
  });
};

ABADisclosureDialog.defaultProps = {
  documentContent: null
};

// The ABAD SDK expects one of the following three values for the "serviceEnvironment" prop
// 1. "development" for the dev/tes720 environment
// 2. "stage" for the stage/qa environment
// 3. "production" for the production environment
var getAbadServiceEnvironment = () => {
  switch (process.env.BUILD_ENV) {
    case 'production':
      return 'production';

    case 'stage':
      return 'stage';
    // Will include 'dev', 'local', and all og microenvs

    default:
      return 'development';
  }
};

var onFailure = e => captureException(e);

var ABADisclosureDialogContainer = _ref => {
  var {
    encodedZuid
  } = _ref;
  var [isOpen, setIsOpen] = useState(false);
  var [documentContent, setDocumentContent] = useState(null);
  var abadClient = useMemo(() => AbadEcClient.abadClient({
    appId: 'static-zo-growth',
    productId: 'Z',
    serviceEnvironment: getAbadServiceEnvironment()
  }), []);

  var onSuccess = text => {
    setDocumentContent(parse(text));
    setIsOpen(true); // abad sdk requires callback to return true to acknowledge Susan has seen the abad

    return true;
  };

  useEffect(() => {
    abadClient.show({
      asHtml: true,
      callback: onSuccess,
      encodedZuid,
      onFailure
    }); // eslint-disable-next-line zillow/react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(ABADisclosureDialog, {
    documentContent: documentContent,
    isOpen: isOpen,
    onClose: () => {
      setIsOpen(false);
    },
    "data-testid": "lead-abad-display-dialog"
  });
};

ABADisclosureDialogContainer.defaultProps = {
  encodedZuid: ''
};

var _templateObject$3, _templateObject2$2, _templateObject3$1;
var isMobile$2 = getIsMobile(); // ******** Styles ***************
// targeting svg helps us override parent styles (currently HDC) that trickle down to the icon, do not change until re-tested

var StyledWrapper = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n    > svg[class^='Icon-'] {\n        height: 43px;\n        width: 43px;\n        color: ", ";\n    }\n\n    div.other-ways-to-sell {\n        max-width: unset;\n        margin: 0 auto;\n        ", "\n\n        h5 {\n            font-family: ", ";\n            font-size: ", "px;\n        }\n    }\n"])), token('colors.green500'), mediaMixin('md', css(["max-width:80%;"])), token('fonts.sansSerif'), token('fontSizes.h6'));
var StyledBodyHeading = styled(Heading)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n    font-size: ", "px;\n"])), token('fontSizes.bodySmallHeading'));
var StyledSubHeading = styled(Paragraph)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    font-size: ", "px;\n"])), token('fontSizes.bodySmallHeading')); // ******** GA Tracking ***************

var gaAction = 'MoreWaysToSell';

var _onClickAgentFinder = landingPage => track({
  action: gaAction,
  category: landingPage,
  label: 'AgentFinder_Click'
});

var _onClickFsbo = landingPage => track({
  action: gaAction,
  category: landingPage,
  label: 'FSBO_Click'
});

var _onClickSellerGuide = landingPage => track({
  action: gaAction,
  category: landingPage,
  label: 'SellersGuide_Click'
});

var ConfirmationDialog = _ref => {
  var {
    content,
    onClose,
    encodedZuid,
    isOpen,
    isEligible,
    landingPage
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen && isEligible && /*#__PURE__*/React.createElement(ABADisclosureDialogContainer, {
    encodedZuid: encodedZuid
  }), /*#__PURE__*/React.createElement(ModalDialog, {
    size: isMobile$2 ? ModalDialog.SIZES.FULL_SCREEN : ModalDialog.SIZES.MD,
    header: /*#__PURE__*/React.createElement(Heading, {
      style: {
        fontSize: '16px'
      },
      level: "6"
    }, content.header),
    body: /*#__PURE__*/React.createElement(StyledWrapper, {
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(IconCheckmarkCircle, null), /*#__PURE__*/React.createElement(Spacer, {
      marginTop: "md"
    }), /*#__PURE__*/React.createElement(StyledBodyHeading, {
      level: "6"
    }, content.bodyHeading), /*#__PURE__*/React.createElement(StyledSubHeading, {
      marginY: "sm"
    }, content.bodySubHeading), !isEligible && /*#__PURE__*/React.createElement(OtherWaysToSell, {
      dividerColor: token('colors.yellow400'),
      onClickAgentFinder: () => _onClickAgentFinder(landingPage),
      onClickFsbo: () => _onClickFsbo(landingPage),
      onClickSellerGuide: () => _onClickSellerGuide(landingPage),
      header: "More ways we can help you sell"
    }), /*#__PURE__*/React.createElement(Spacer, {
      style: {
        margin: 'auto',
        width: '186px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      marginY: "sm",
      fluid: true,
      buttonType: "primary",
      onClick: onClose,
      "data-testid": "close-btn"
    }, "Close"))),
    onClose: onClose,
    isOpen: isOpen,
    "data-testid": "lead-confirmation-dialog"
  }));
};

ConfirmationDialog.defaultProps = {
  encodedZuid: '',
  isEligible: false,
  isOpen: false,
  landingPage: '',
  onClose: () => {}
};

var config = {
  PARTNER_LEADS: {
    ELIGIBLE: {
      CONFIRMATION_DIALOG: {
        bodyHeading: 'Thanks for contacting us!',
        bodySubHeading: 'We’ll contact you soon to connect you with a local participating Zillow Premier Agent partner.',
        header: 'Message sent'
      },
      CONTACT_FORM: {
        bodyHeading: 'How can we reach you?',
        bodySubHeading: 'A Zillow Advisor will reach out to connect you with a local participating Zillow Premier Agent partner.',
        header: 'Good news! Participating Zillow Premier Agent partners are available in your area.'
      }
    },
    INELIGIBLE: {
      CONFIRMATION_DIALOG: {
        bodyHeading: 'You’re on the list!',
        bodySubHeading: 'We’ll let you know when participating Zillow Premier Agent partners become available in your area.',
        header: 'Message sent'
      },
      CONTACT_FORM: {
        bodyHeading: 'We’ll let you know as soon as that changes.',
        bodySubHeading: 'Please fill out your contact information. We’ll only contact you once participating Zillow Premier Agent partners are available in your area.',
        header: 'Participating Zillow Premier Agent partners aren’t currently available in your area.'
      }
    }
  },
  ZILLOW_360: {
    ELIGIBLE: {
      CONFIRMATION_DIALOG: {
        bodyHeading: 'Thanks for contacting us about Zillow 360!',
        bodySubHeading: 'A Zillow Advisor will contact you soon to learn more about your needs and help determine your best options to save.',
        header: 'Message sent'
      },
      CONTACT_FORM: {
        bodyHeading: 'How can we reach you?',
        bodySubHeading: 'A Zillow Advisor will contact you to discuss your needs and review your options, including potential savings.',
        header: 'Good news! Zillow 360 is available in your area.'
      }
    },
    INELIGIBLE: {
      CONFIRMATION_DIALOG: {
        bodyHeading: 'Thanks for your interest!',
        bodySubHeading: 'We’ll let you know when Zillow 360 becomes available in your area.',
        header: 'Message sent'
      },
      CONTACT_FORM: {
        bodyHeading: 'We’ll let you know as soon as that changes.',
        bodySubHeading: 'Please provide your contact information so we can keep you up to date.',
        header: 'Sorry, Zillow 360 isn’t available in your area at this time.'
      }
    }
  }
};

var PhoneNumbers = {
  ZILLOW_ADVISOR_TEAM: '18339633377',
  ZILLOW_ADVISOR_TEAM_DISPLAY: '1-833-ZOFFERS'
};

var ZatPhoneLink = () => /*#__PURE__*/React.createElement(Anchor, {
  href: "tel:".concat(PhoneNumbers.ZILLOW_ADVISOR_TEAM)
}, PhoneNumbers.ZILLOW_ADVISOR_TEAM_DISPLAY);

var Messages = {
  ADDRESS_NOT_FOUND: "Sorry, we couldn't find that address.",
  CONTACT_FORM_ERROR: "Sorry, we're having technical issues, please try again.",
  CONTACT_FORM_ERROR_LONG: 'Sorry, we are experiencing some technical difficulties right now. Please try again after some time.',
  CONTACT_FORM_INVALID_EMAIL: 'Please enter a valid email address to get updates.',
  CONTACT_FORM_SUBMIT_FAILURE: "Sorry, we couldn't get an offer at this time, please try again.",
  CONTACT_FORM_SUBMIT_INVALID_EMAIL: 'Please enter a valid email address to get an offer.',
  DUPLICATE_REQUEST: /*#__PURE__*/React.createElement(React.Fragment, null, "We are unable to process your request. If you would like to make changes to an existing request for offers, call us at ", /*#__PURE__*/React.createElement(ZatPhoneLink, null), "."),
  SERVER_ERROR: 'Sorry, our service is unavailable at this time.',
  USERS_OWN_DUPLICATE_REQUEST: /*#__PURE__*/React.createElement(React.Fragment, null, "You have an open offer request on this home. If you would like to make changes to this request, call us at ", /*#__PURE__*/React.createElement(ZatPhoneLink, null), ".")
};

// leadTypes match OASIS model response
// https://gitlab.zgtools.net/zillow-offers/growth/oasis-model/-/blob/master/src/main/java/com/zillow/offeravail/model/api/LeadType.java
var LeadTypes = {
  PARTNER_LEADS: 'PARTNER_LEADS',
  PARTNER_LEADS_INTEREST_LIST: 'PARTNER_LEADS_INTEREST_LIST',
  ZILLOW_360: 'ZILLOW_360'
};

// These values are based on, but not necessarily match OASIS's surfaceIDs:
// https://zwiki.zillowgroup.net/display/SELL/OASIS+upsell+endpoint+v2+design
var SurfaceIds = {
  FSHDP: 'fshdp',
  HMIMHW: 'hmimhw',
  ODASH: 'odash',
  OMHDP: 'omhdp',
  TRULIA_HDP: 'trulia-hdp',
  Z360_LP: 'z360-lp'
};

var JumpstartErrorTypes = {
  INVALID_EMAIL: '7939',
  ITERABLE_INVALID_EMAIL: '7926'
};

var {
  PARTNER_LEADS_INTEREST_LIST
} = LeadTypes;
var axiosInstance = axios.create({
  timeout: 30000,
  validateStatus: status => status >= 200 && status < 300
});
var getLeadType = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (zpid) {
    try {
      var {
        data
      } = yield axiosInstance.get("/jmp/lead-eligibility?zpid=".concat(zpid));
      return data.leadType;
    } catch (e) {
      captureException(e);
      return PARTNER_LEADS_INTEREST_LIST;
    }
  });

  return function getLeadType(_x) {
    return _ref.apply(this, arguments);
  };
}();
var query = "\n    query PropertyInfoQuery($zpid: ID!) {\n        property(zpid: $zpid) {\n            zpid\n            state\n            county\n            city\n            zipcode\n            streetAddress\n            homeType\n            zestimate\n            address {\n                neighborhood\n            }\n            listingTypeDimension\n            zillowOfferMarket {\n                name\n            }\n        }\n    }\n";
var getQuery = zpid => ({
  operationName: 'PropertyInfoQuery',
  query,
  variables: {
    zpid
  }
});
var getPropertyInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (zpid) {
    try {
      var {
        data
      } = yield axiosInstance.post('/graphql/', getQuery(zpid));
      var {
        zillowOfferMarket,
        streetAddress,
        city,
        state,
        zipcode
      } = data.data.property;
      return {
        address: streetAddress && city && state && zipcode ? "".concat(streetAddress, ", ").concat(city, ", ").concat(state, " ").concat(zipcode) : '',
        zoMarketName: zillowOfferMarket !== null && zillowOfferMarket !== void 0 && zillowOfferMarket.name ? zillowOfferMarket.name : '',
        zpid
      };
    } catch (e) {
      captureException(e);
      return null;
    }
  });

  return function getPropertyInfo(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var analyticsEventActions;

(function (analyticsEventActions) {
  analyticsEventActions["interestListModal"] = "InterestListModal";
  analyticsEventActions["leadFormModal"] = "LeadFormModal";
})(analyticsEventActions || (analyticsEventActions = {}));

var DAEDialogs;

(function (DAEDialogs) {
  DAEDialogs["CONFIRMATION"] = "CONFIRMATION";
  DAEDialogs["CONTACT_FORM"] = "CONTACT_FORM";
})(DAEDialogs || (DAEDialogs = {}));

var EligibilityTypes;

(function (EligibilityTypes) {
  EligibilityTypes["ELIGIBLE"] = "ELIGIBLE";
  EligibilityTypes["INELIGIBLE"] = "INELIGIBLE";
})(EligibilityTypes || (EligibilityTypes = {}));

var JMP_BASE$1 = '/jmp';
var ZILLOW_BASE = 'https://zillow.com';
var ZILLOWGROUP_BASE = 'https://www.zillowgroup.com';
var Urls$1 = {
  AGENTS: "".concat(ZILLOW_BASE, "/z/offers/agents/"),
  CHESS_AUTOCOMPLETE_URL: 'https://www.zillowstatic.com/autocomplete/v3/suggestions',
  CHESS_AUTOCOMPLETE_URL_QA: 'https://static.qa.zillow.net/autocomplete/v3/suggestions',
  CLAIM_YOUR_HOME: "".concat(ZILLOW_BASE, "/sellerlanding/claimyourhome/"),
  HDP_PATH: "/homes",
  PRICING: "".concat(ZILLOW_BASE, "/z/offers/pricing/"),
  TERMS_OF_SERVICE_PATH: '/corp/Terms.htm',
  TIME_TO_SELL: "".concat(ZILLOW_BASE, "/sellers-guide/average-time-to-sell-a-house/"),
  ZILLOW_GROUP_COST_OF_ZO_VS_TRADITIONAL_SALE: "".concat(ZILLOWGROUP_BASE, "/news/the-cost-of-zillow-offers-vs-a-traditional-sale/"),
  ZILLOW_GROUP_IBUYER_REPORT: "".concat(ZILLOWGROUP_BASE, "/ibuyer-report/"),
  ZILLOW_OFFERS_FAQ: "".concat(ZILLOW_BASE, "/marketing/zillow-offers-faq/"),
  ZILLOW_OFFERS_SELLER_LEAD_EMAIL_WAITLIST_SUBMIT: "".concat(JMP_BASE$1, "/leads/email-waitlist"),
  ZILLOW_OFFERS_SELLER_LEAD_NURTURE_SUBMIT: "".concat(JMP_BASE$1, "/leads/nurture"),
  ZILLOW_OFFERS_SELLER_LEAD_PARTNER_LEADS_INTEREST_LIST_SUBMIT: "".concat(JMP_BASE$1, "/leads/partner-leads-interest-list"),
  ZILLOW_OFFERS_SELLER_QUESTIONNAIRE_SUBMIT: "".concat(JMP_BASE$1, "/submit-answers")
};

var {
  ZILLOW_360,
  PARTNER_LEADS
} = LeadTypes;

var Main = _ref => {
  var {
    eligibleLeadTypes = [ZILLOW_360],
    contactFormGaActionPrefix = '',
    isOpen = false,
    lead = {
      address: '',
      zoMarketName: '',
      zpid: ''
    },
    leadType,
    onLeadSubmitSucceeded = () => {},
    onLeadSubmitFailed = () => {},
    onDialogClose = () => {},
    useUserInfo = {
      email: '',
      name: '',
      phone: ''
    },
    modalMessaging = config,
    landingPage = '',
    leadSource = '',
    surfaceID = ''
  } = _ref;
  var [dialog, setDialog] = useState('');
  var [leadPayload, setLeadPayload] = useState(lead);
  var [encodedZuid, setEncodedZuid] = useState('');
  var [leadSubmissionError, setLeadSubmissionError] = useState('');
  var [leadTypeResolved, setLeadTypeResolved] = useState(leadType !== null && leadType !== void 0 ? leadType : '');
  var contentVariant = surfaceID === SurfaceIds.Z360_LP ? ZILLOW_360 : PARTNER_LEADS;
  var isEligible = leadTypeResolved && (!eligibleLeadTypes.length && leadTypeResolved !== 'PARTNER_LEADS_INTEREST_LIST' || eligibleLeadTypes.includes(leadTypeResolved));
  var eligibilityType = isEligible ? EligibilityTypes.ELIGIBLE : EligibilityTypes.INELIGIBLE;
  var {
    email,
    name,
    phone
  } = useUserInfo;

  var closeDialog = () => setDialog('');

  var onContactFormDialogClose = () => {
    closeDialog();
    onDialogClose(DAEDialogs.CONTACT_FORM);
  };

  var onConfirmationDialogClose = () => {
    closeDialog();
    onDialogClose(DAEDialogs.CONFIRMATION);
  };

  var onEligibleSubmit = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (_ref2) {
      var _response$data;

      var {
        actionPrefix,
        payload
      } = _ref2;
      track({
        action: "".concat(actionPrefix).concat(analyticsEventActions.leadFormModal),
        category: landingPage,
        label: 'LeadForm_Submit'
      });
      var response = yield axiosInstance.post(Urls$1.ZILLOW_OFFERS_SELLER_LEAD_NURTURE_SUBMIT, payload);
      var zuid = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.encodedZuid;
      setDialog(DAEDialogs.CONFIRMATION);
      setEncodedZuid(zuid);
    });

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [landingPage]);
  var onIneligibleSubmit = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* (_ref4) {
      var {
        actionPrefix,
        payload
      } = _ref4;
      track({
        action: "".concat(actionPrefix).concat(analyticsEventActions.interestListModal),
        category: landingPage,
        label: 'InterestList_Submit'
      });
      yield axiosInstance.post(Urls$1.ZILLOW_OFFERS_SELLER_LEAD_PARTNER_LEADS_INTEREST_LIST_SUBMIT, payload);
      setDialog(DAEDialogs.CONFIRMATION);
    });

    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }(), [landingPage]);
  var onLeadSubmit = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(function* (leadFormData) {
      var actionPrefix = surfaceID === SurfaceIds.Z360_LP ? '360' : 'PL';

      try {
        var payload = _objectSpread2(_objectSpread2(_objectSpread2({}, leadFormData), leadPayload), {}, {
          leadSource: leadSource || surfaceID,
          leadType: leadTypeResolved,
          zpid: leadPayload.zpid
        });

        if (eligibilityType === EligibilityTypes.ELIGIBLE) {
          yield onEligibleSubmit({
            actionPrefix,
            payload
          });
        } else {
          yield onIneligibleSubmit({
            actionPrefix,
            payload
          });
        }

        onLeadSubmitSucceeded();
      } catch (error) {
        var _error$response, _error$response$data;

        var leadSubmissionErrorMessage = Messages.CONTACT_FORM_ERROR;
        var errorType = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.errorType;

        if (errorType === JumpstartErrorTypes.INVALID_EMAIL || errorType === JumpstartErrorTypes.ITERABLE_INVALID_EMAIL) {
          leadSubmissionErrorMessage = Messages.CONTACT_FORM_INVALID_EMAIL;
        }

        onLeadSubmitFailed();
        setLeadSubmissionError(leadSubmissionErrorMessage);
        captureException(error);
      }
    });

    return function (_x3) {
      return _ref6.apply(this, arguments);
    };
  }(), [eligibilityType, leadPayload, leadSource, leadTypeResolved, onEligibleSubmit, onIneligibleSubmit, onLeadSubmitFailed, onLeadSubmitSucceeded, surfaceID]);
  useEffect(() => {
    if (isOpen && lead.zpid) {
      if (!leadType) {
        // no leadType provided, trying to get leadType from Jumpstart ourselves
        // eslint-disable-next-line no-void
        void getLeadType(lead.zpid).then(l => setLeadTypeResolved(l));
      } else {
        setLeadTypeResolved(leadType);
      }

      if (lead.address && lead.zoMarketName) {
        // everything is provided to us via props, show the contact form
        setLeadPayload(lead);
      } else {
        // we only have zpid
        // eslint-disable-next-line no-void
        void getPropertyInfo(lead.zpid).then(p => {
          if (p) {
            setLeadPayload(p);
          }
        });
      } // assuming OASIS only requires user info and zpid, we can proceed even without lead info


      setDialog(DAEDialogs.CONTACT_FORM);
    }
  }, [isOpen, lead, leadType]);

  if (!modalMessaging[contentVariant]) {
    // this prevents the component from crashing while we're resolving the leadType
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContactFormDialog, {
    prefillContactInfo: {
      email,
      name,
      phone
    },
    isOpen: dialog === DAEDialogs.CONTACT_FORM,
    leadSubmissionError: leadSubmissionError,
    onClose: onContactFormDialogClose,
    content: modalMessaging[contentVariant][eligibilityType].CONTACT_FORM,
    isEligible: eligibilityType === EligibilityTypes.ELIGIBLE,
    landingPage: landingPage,
    contactFormGaActionPrefix: contactFormGaActionPrefix,
    onLeadSubmit: onLeadSubmit
  }), /*#__PURE__*/React.createElement(ConfirmationDialog, {
    encodedZuid: encodedZuid,
    isEligible: eligibilityType === EligibilityTypes.ELIGIBLE,
    isOpen: dialog === DAEDialogs.CONFIRMATION,
    landingPage: landingPage,
    onClose: onConfirmationDialogClose,
    content: modalMessaging[contentVariant][eligibilityType].CONFIRMATION_DIALOG
  }));
};

export default Main;
